import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

enum LeaseFeePaymentCycle {
  everyMonthly = '1',
  everyTwoMonths = '2',
  everyThreeMonths = '3',
  everyFourMonths = '4',
  semiannually = '5',
  annually = '6',
}

const nameConfig = {
  everyMonthly: new Map([
    [Locale.ja, '毎月'],
    [Locale.en, 'Every Monthly'],
  ]),
  everyTwoMonths: new Map([
    [Locale.ja, '2ヶ月毎'],
    [Locale.en, 'Every Two Months'],
  ]),
  everyThreeMonths: new Map([
    [Locale.ja, '3ヶ月毎'],
    [Locale.en, 'Every Three Months'],
  ]),
  everyFourMonths: new Map([
    [Locale.ja, '4ヶ月毎'],
    [Locale.en, 'Every Four Months'],
  ]),
  semiannually: new Map([
    [Locale.ja, '半年毎'],
    [Locale.en, 'Semiannually'],
  ]),
  annually: new Map([
    [Locale.ja, '1年毎'],
    [Locale.en, 'Annually'],
  ]),
};

const toEnum = rawValueToEnum(LeaseFeePaymentCycle, LeaseFeePaymentCycle.everyMonthly);
const toDisplay = enumToName(LeaseFeePaymentCycle, nameConfig);
const toDisplayWithPrefix = enumToName(LeaseFeePaymentCycle, nameConfig, { prefix: true });

export const leaseFeePaymentCycle = {
  enum: LeaseFeePaymentCycle,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { LeaseFeePaymentCycle };
